import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import Layout from './components/layout/Layout';
import Contacto from './pages/Contact';
import Persianas  from './pages/Persianas';
import Toldos from './pages/Toldos';
import AutomationPremium from './pages/Automatizacion';
import Nosotros from './pages/About';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/producto/:id" element={<ProductDetail />} />
          <Route path="/contacto" element={<Contacto />} /> 
          <Route path="/persianas" element={<Persianas  />} />
          <Route path="/toldos" element={<Toldos />} />
          <Route path="/automatizacion" element={<AutomationPremium />} />
          <Route path="/nosotros" element={<Nosotros />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;